import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";
import { pageHead } from "@/lib/seo";
import { softwareApplicationSchema, faqPageSchema } from "@/utils/schema";

export const Route = createFileRoute("/")({
  head: () => ({
    ...pageHead("/", "en"),
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(softwareApplicationSchema),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify(faqPageSchema),
      },
    ],
  }),
  component: Index,
});
